module.exports = __webpack_public_path__ + "img/neckcurve_small.b30b684a.png";